import React, { useRef } from "react";
import { SeriesView } from "./SeriesView";
import { ui } from "../constants";
import { SetsView } from "./SetsView";
import { ExportView } from "./ExportView";
import { isEqual } from "lodash";
import styled from "@emotion/styled";
import { SetsTSButtonMenu } from "./SetsTSButtonMenu";
import { ResultsButtonMenu } from "./ResultsButtonMenu";
import { useSettings } from "./SettingsProvider";
import { useUserData } from "./UserDataProvider";

const Main = styled.div`
  display: grid;
  padding: 15px;
  height: 100%;
  width: 100%;
  gap: 20px;
  grid-template-columns: minmax(0, 35fr) minmax(0, 65fr);
  grid-template-rows: minmax(0, 1fr);
`;

const StyledExportView = styled(ExportView)`
  height: 100%;
`;

const StyledSetsView = styled(SetsView)`
  height: 100%;
`;

const StyledSeriesView = styled(SeriesView)`
  width: 100%;
  height: 100%;
`;

const SetsExportFlex = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
  height: 100%;
`;

export const SetsExportView = React.memo(
  ({ onSetFilter }) => {
    const {
      settings: { lang },
    } = useSettings();
    const {
      activeSet,
      collection,
      collectionRange,
      collectionCount,
      setFunctions,
    } = useUserData();
    const prevActiveSet = useRef(null);

    var resetScrollOnChange = false;
    if (activeSet !== prevActiveSet.current) {
      prevActiveSet.current = activeSet;
      resetScrollOnChange = true;
    }

    // const seriesOptionsButtonRenderer = (series, sets) =>
    // <ResultsButtonMenu
    //   sets={sets}
    //   series={series}
    //   onAddSet={onAddSet}
    //   onAddToSet={onAddToSet}
    //   onRemoveFromSet={onRemoveFromSet}
    //   lang={lang}/>

    const optionsButtonRenderer = (
      content,
      hover,
      selectSeries,
      unselectSeries,
      selected,
    ) => (
      <SetsTSButtonMenu
        content={content}
        hover={hover}
        unselectSeries={unselectSeries}
        selectSeries={selectSeries}
        selected={selected}
        onSetFilter={onSetFilter}
      />
    );

    const title = (
      <span style={{ fontWeight: 700 }}>
        {ui.labels.resultsTitle[lang] + " in "}
        <i>{activeSet}</i>
      </span>
    );

    return (
      <Main>
        <SetsExportFlex>
          <StyledSetsView />
          <StyledExportView />
        </SetsExportFlex>
        {activeSet && (
          <StyledSeriesView
            series={collection}
            seriesCount={collectionCount}
            range={collectionRange}
            loadRange={setFunctions.loadCollectionRange}
            title={title}
            resetScrollOnChange={resetScrollOnChange}
            optionsButtonRenderer={optionsButtonRenderer}
          />
        )}
      </Main>
    );
  },
  (prevProps, nextProps) => {
    return isEqual(prevProps.style, nextProps.style);
  },
);
